var [html,css,node,react,mysql,js,mongodb,java,bootstrap] = [
    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" />,
    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" />,
    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original-wordmark.svg" />,
    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" />,
    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original-wordmark.svg" />,
    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" />,
    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" />,
    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original-wordmark.svg" />,
    <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg" />

]




var Projects = [
    {
        key: 1,
        name: "Matching System",
        img: "https://i.ibb.co/0fWvbvh/Screenshot-2022-01-23-195034.png/to/img.png",
        description: "An Online Matching System with DataBase Connectivity",
        link: 'https://github.com/SanchitSah12/MatchingWebsite',
        frameworks:[html,mysql,css,js,node,bootstrap]

    }, {
        key: 2,
        name: "Bus Reservation System",
        img: "https://user-images.githubusercontent.com/72809971/150920507-9ece0bfb-d766-47ac-83e3-0499c1579c04.png",
        description: "A DBMS Bus Reservation System made using JAVAFX and MySql",
        link: 'https://github.com/SanchitSah12/Bus-Reservation-System-using-JAVAFX-and-MYSql',
        frameworks:[java,mysql]
    }
    , {
        key: 3,
        name: "Notes App",
        img: "https://user-images.githubusercontent.com/72809971/152547913-355b0ebe-e0a7-4733-8db6-ee80d62b4aa2.png",
        description: "An Online Matching System with DataBase Connectivity",
        link: 'https://github.com/SanchitSah12/MatchingWebsite',
        frameworks:[html,css,node,mongodb]

    },
    

];


export default Projects;